import { z } from "zod/v4";
import { rankingRowSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export interface RankingsParams {
	athlete?: string;
	rankingType?: string;
	ageGroup?: string;
	season?: number;
	minPoints?: number;
	limit?: number;
}

export const rankings = {
	list: (params: RankingsParams = {}) => {
		const query = new URLSearchParams();
		if (params.athlete) query.set("athlete", params.athlete);
		if (params.rankingType) query.set("rankingType", params.rankingType);
		if (params.ageGroup) query.set("ageGroup", params.ageGroup);
		if (params.season != null) query.set("season", String(params.season));
		if (params.minPoints != null) query.set("minPoints", String(params.minPoints));
		if (params.limit) query.set("limit", String(params.limit));
		const qs = query.toString();
		return fetchApi(`/rankings${qs ? `?${qs}` : ""}`, z.array(rankingRowSchema));
	},
};
